
(function () {
  var selectors = {
    input: '[data-custom-filter-input]',
    nativeForm: '[data-collection-filters-form]',
    filters: '[data-collection-filters]',
  };

  var swatchesDataPromise = null;

  // 스와치 색상 데이터(JSON)를 최초 1회만 fetch해서 캐싱된 Promise로 재사용
  function getSwatchesData() {
    if (!swatchesDataPromise) {
      if (!window.theme || !theme.assets || !theme.assets.swatches) {
        swatchesDataPromise = Promise.resolve(null);
      } else {
        swatchesDataPromise = fetch(theme.assets.swatches)
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            return null;
          });
      }
    }
    return swatchesDataPromise;
  }

  // 네이티브 필터 폼 안에서 특정 파라미터명/값을 가진 hidden input을 찾아 반환
  function findMirrorInput(form, paramName, value) {
    var hiddenInputs = form.querySelectorAll('input[type="hidden"]');
    for (var i = 0; i < hiddenInputs.length; i++) {
      if (hiddenInputs[i].name === paramName && hiddenInputs[i].value === value) {
        return hiddenInputs[i];
      }
    }
    return null;
  }

  // 체크박스 체크 여부에 맞춰 네이티브 폼에 hidden input을 추가하거나 제거(네이티브 필터와 값 동기화)
  function setMirrorInput(form, paramName, value, shouldExist) {
    var existing = findMirrorInput(form, paramName, value);

    if (shouldExist) {
      if (existing) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = paramName;
      input.value = value;
      input.setAttribute('data-custom-filter-mirror', paramName);
      form.appendChild(input);
    } else if (existing) {
      existing.remove();
    }
  }

  // 커스텀 체크박스형 필터(swatch 등)를 다루는 커스텀 엘리먼트 <ohora-custom-filter>
  class OhoraCustomFilter extends HTMLElement {
    // DOM에 연결될 때 체크박스 바인딩, URL 기준 체크 상태 동기화, 스와치 색상 적용을 초기 실행
    connectedCallback() {
      this.onCheckboxChangeBound = this.onCheckboxChange.bind(this);

      this.bindInputs();
      this.syncCheckedFromURL();
      this.applySwatchColors();
      this.observeFiltersContentChange();
    }

    // DOM에서 제거될 때 감시자 해제
    disconnectedCallback() {
      if (this.filtersObserver) this.filtersObserver.disconnect();
    }

    // [data-collection-filters]의 DOM 변경(= 다른 필터가 적용되어 상품 목록/필터
    // 카운트가 갱신됨)을 감시해 이 섹션도 다시 fetch합니다. collection-filters.js와
    // 동일한 mode-agnostic 방식입니다: 벤더의 Filters 클래스는 collection.liquid의
    // filter_mode가 'default'일 때만 renderFilters()를 타면서 'theme:filters:init'
    // 이벤트를 쏘고, 'tag'/'group' 모드에서는 renderTagFiltersProducts()로
    // [data-collection-filters]의 innerHTML만 바꾸고 이벤트는 안 쏩니다. 이벤트 하나에만
    // 의존하면 tag/group 모드 컬렉션에서는 다른 필터를 바꿔도 이 섹션이 전혀 갱신되지
    // 않아, count=0이 된 값이 계속 남아 보이는 버그가 생깁니다. 그래서 이벤트 대신
    // [data-collection-filters] 자체의 DOM 변화를 관찰합니다 - 두 모드 모두 결국
    // 그 요소의 innerHTML을 바꾸기 때문에 모드에 상관없이 동작합니다.
    observeFiltersContentChange() {
      var filters = document.querySelector(selectors.filters);
      if (!filters) return;

      var self = this;
      this.filtersObserver = new MutationObserver(function () {
        self.onFiltersInit();
      });
      this.filtersObserver.observe(filters, {childList: true, subtree: true});
    }

    // 실제 상품 목록을 제출하는 네이티브 필터 폼 엘리먼트를 조회
    getNativeForm() {
      return document.querySelector(selectors.nativeForm);
    }

    // 커스텀 체크박스 변경 시 네이티브 폼에 hidden input을 반영하고 모바일 자동오픈 억제 후 폼 제출 이벤트 발생
    // 이 섹션은 항상 필터 하나(target_filter)만 다루므로, 하나를 체크하면 같은 그룹의
    // 나머지는 전부 강제로 해제해서 실질적으로 단일선택처럼 동작하게 합니다. 체크박스
    // 자체는 그대로 두기 때문에 다시 클릭해서 해제하는 기본 동작은 그대로 유지됩니다.
    onCheckboxChange(event) {
      var checkbox = event.currentTarget;
      var paramName = checkbox.getAttribute('data-param-name');
      var value = checkbox.getAttribute('data-value');
      var form = this.getNativeForm();

      if (!form || !paramName) return;

      if (checkbox.checked) {
        var self = this;
        this.querySelectorAll(selectors.input).forEach(function (other) {
          if (other === checkbox || !other.checked) return;
          other.checked = false;
          setMirrorInput(form, other.getAttribute('data-param-name'), other.getAttribute('data-value'), false);
        });
      }

      // 네이티브 필터 목록(snippets/filter.liquid)에 같은 파라미터명을 가진 체크박스가
      // 따로 떠 있는 경우(둘 다 노출되는 구성), 그쪽도 값까지 맞춰서 동기화합니다:
      // 지금 선택된 값이면 체크, 아니면 해제.
      var nativeInputs = document.querySelectorAll('input.filter__input[name="' + paramName + '"]');
      nativeInputs.forEach(function (nativeInput) {
        nativeInput.checked = checkbox.checked && nativeInput.value === value;
      });

      // 네이티브 체크박스가 실제로 존재하면 그게 폼에 값을 직접 제출하므로,
      // 굳이 hidden mirror까지 같이 만들어서 값이 중복 제출되지 않게 합니다.
      // (완전히 숨겨진 구성이라 네이티브 카운터파트가 없을 때만 mirror를 사용)
      if (nativeInputs.length === 0) {
        setMirrorInput(form, paramName, value, checkbox.checked);
      }

      // 이 섹션도 네이티브 필터 폼을 드로어 밖에서 제출시키는 경우라서,
      // collection-filters.js에 원래 닫혀 있었으면 벤더 로직이
      // 억지로 연 모바일 드로어를 되돌려달라고 알려줍니다.
     var filters = document.querySelector('[data-collection-filters]');
var wasVisible = !!(
  filters &&
  filters.classList.contains('collection__filters--visible')
);

if (!wasVisible && window.ohrSuppressFiltersAutoOpen) {
  window.ohrSuppressFiltersAutoOpen();
}

form.dispatchEvent(new Event('input', {bubbles: true}));



// 모바일 퀵 필터는 드로어 밖에서 동작하므로
// 테마 필터 로직이 남긴 scroll lock을 강제로 해제
if (!wasVisible) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      var filters = document.querySelector('[data-collection-filters]');

      if (filters) {
        filters.classList.remove('collection__filters--visible');
      }

      document.dispatchEvent(
        new CustomEvent('theme:scroll:unlock', {
          bubbles: true,
          detail: 300
        })
      );
    });
  });
}

if (!wasVisible) {
  setTimeout(function () {
    document.dispatchEvent(
      new CustomEvent('theme:scroll:unlock', {
        bubbles: true,
        detail: 300
      })
    );
  }, 100);
}
    }

    // 내부 체크박스들에 change 이벤트 리스너를 (중복 방지 후) 바인딩
    bindInputs() {
      var self = this;
      this.querySelectorAll(selectors.input).forEach(function (checkbox) {
        checkbox.removeEventListener('change', self.onCheckboxChangeBound);
        checkbox.addEventListener('change', self.onCheckboxChangeBound);
      });
    }

    // data-swatch 속성을 가진 요소에 스와치 데이터에서 찾은 색상/이미지를 CSS 변수로 적용
    applySwatchColors() {
      var swatchEls = this.querySelectorAll('[data-swatch]');
      if (!swatchEls.length) return;

      getSwatchesData().then(function (data) {
        var colors = (data && data.colors) || [];
        if (!colors.length) return;

        var base = (window.theme && theme.assets && theme.assets.base) || '/';

        swatchEls.forEach(function (el) {
          var name = (el.getAttribute('data-swatch') || '').toLowerCase().replace(/\s/g, '');
          if (!name) return;

          var match = null;
          for (var i = 0; i < colors.length; i++) {
            var key = Object.keys(colors[i])[0];
            if (key && key.toLowerCase().replace(/\s/g, '') === name) {
              match = colors[i][key];
              break;
            }
          }
          if (!match) return;

          if (/\.(jpg|jpeg|png|svg|gif)$/i.test(match)) {
            el.style.setProperty('--swatch', '#888888');
            el.style.setProperty('background-image', 'url(' + base + match + ')');
          } else {
            el.style.setProperty('--swatch', match);
          }
        });
      });
    }

    // 현재 URL 쿼리 파라미터를 읽어 체크박스들의 체크 상태를 맞춤
    syncCheckedFromURL() {
      var params = new URLSearchParams(window.location.search);

      this.querySelectorAll(selectors.input).forEach(function (checkbox) {
        var paramName = checkbox.getAttribute('data-param-name');
        var value = checkbox.getAttribute('data-value');
        if (!paramName) return;
        checkbox.checked = params.getAll(paramName).indexOf(value) > -1;
      });
    }

    // 현재 필터 쿼리로 섹션을 다시 fetch해 이 커스텀 엘리먼트 전체 내용을 교체하고
    // 바인딩/체크 상태를 재적용합니다.
    // [data-custom-filter-content]만 부분적으로 골라 교체하지 않고 <ohora-custom-filter>
    // 루트 엘리먼트 자체를 통째로 교체하는 이유: 다른 필터 조합 때문에 이 필터의 값이
    // 전부 사라지면(예: Shopify가 결과 0개인 값들을 filter.values에서 통째로 빼버림)
    // 서버 응답에는 <ohora-custom-filter></ohora-custom-filter>만 텅 비어 오고
    // [data-custom-filter-content] 자체가 존재하지 않습니다. 그 부분만 골라
    // 교체하려 하면 셀렉터가 못 찾아서 그대로 리턴해버리고, 화면엔 그 전(필터 적용 전)
    // 목록이 그대로 "고아 상태"로 계속 남아있게 됩니다 - 네이티브 필터는 값이 없으면
    // 통째로 사라지는데 커스텀 필터만 안 사라지던 버그가 바로 이거였습니다. 루트를
    // 통째로 교체하면 값이 없을 땐 자연스럽게 비워지고, 다시 생기면 다시 채워집니다.
    refreshFromServer() {
      var sectionId = this.getAttribute('data-section-id');
      if (!sectionId) return;

      var query = window.location.search ? window.location.search.slice(1) : '';
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + (query ? '&' + query : '');
      var self = this;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var newRoot = new DOMParser().parseFromString(html, 'text/html').querySelector('ohora-custom-filter');
          self.innerHTML = newRoot ? newRoot.innerHTML : '';
          self.bindInputs();
          self.applySwatchColors();
          self.syncCheckedFromURL();
        })
        .catch(function () {});
    }

    // 다른 필터(정렬/가격 등) 변경으로 전체 필터 영역이 갱신될 때 URL 동기화 + 서버 재조회 실행
    onFiltersInit() {
      this.syncCheckedFromURL();
      this.refreshFromServer();
    }
  }

  customElements.define('ohora-custom-filter', OhoraCustomFilter);
})();
